// Messages for portal/TwoFactor (auto-merged into the i18n catalog by lib/i18n.ts).
export const en = {
  'portal.two_factor.head': 'Two-factor — Customer portal',
  'portal.two_factor.title': 'Two-factor authentication',
  'portal.two_factor.recovery_intro':
    'Save these recovery codes somewhere safe — each can be used once.',
  'portal.two_factor.on': 'Two-factor authentication is on.',
  'portal.two_factor.turn_off': 'Turn off',
  'portal.two_factor.scan_intro':
    'Scan this QR code with your authenticator app, then enter the 6-digit code to confirm.',
  'portal.two_factor.code': 'Verification code',
  'portal.two_factor.code_error': 'Code {error}',
  'portal.two_factor.enable': 'Enable two-factor',
}

export const zhTW = {
  'portal.two_factor.head': '雙重驗證 — 客戶入口',
  'portal.two_factor.title': '雙重驗證',
  'portal.two_factor.recovery_intro': '請將這些復原代碼妥善保存 — 每組僅能使用一次。',
  'portal.two_factor.on': '雙重驗證已開啟。',
  'portal.two_factor.turn_off': '關閉',
  'portal.two_factor.scan_intro': '使用驗證器應用程式掃描此 QR 碼，然後輸入 6 位數代碼以確認。',
  'portal.two_factor.code': '驗證代碼',
  'portal.two_factor.code_error': '代碼 {error}',
  'portal.two_factor.enable': '啟用雙重驗證',
}
